class BlogMenu extends HTMLElement {
  constructor() {
    super();

    this.menuList = this.querySelector('.blog-menu__list');
    this.toggle = this.querySelector('.blog-menu__toggle');

    this.article = this.parentElement.querySelector('article');
    this.articleContent = this.article.querySelector('.article-template__content');

    this.sectionType = this.getAttribute('data-section-type') || 'h2';

    if(!this.articleContent) console.error('Article content not found');

    this.addAnchorLinks();

    this.toggle.addEventListener('click', this.toggleMenu.bind(this));
  }

  toggleMenu() {
    this.classList.toggle('active');
  }

  addAnchorLinks() {
    this.articleContent.querySelectorAll(this.sectionType).forEach(heading => {
      heading.id = heading.textContent.toLowerCase().replace(/ /g, '-');

      const anchor = document.createElement('span');
      anchor.setAttribute('data-anchor', heading.id);
      anchor.textContent = heading.textContent;
      anchor.classList.add('blog-menu__link');

      this.menuList.appendChild(anchor);
    });

    this.menuList.querySelectorAll('.blog-menu__link').forEach(link => {
      link.addEventListener('click', this.scrollToAnchor.bind(this));
    });
  }

  scrollToAnchor(e) {
    e.preventDefault();
    const anchor = e.target.getAttribute('data-anchor');
    document.getElementById(anchor).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

customElements.define('blog-menu', BlogMenu);